var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 79,
    viewBox: "0 0 101 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101 0C90.7855 0.5493 19.0235 5.89417 14.007 44.3775C13.3974 48.4911 13.0522 52.6232 12.8253 56.7584L48.1106 29.1869C49.3435 28.2226 51.3458 28.2226 52.5787 29.1869C53.8116 30.1513 53.8116 31.7143 52.5787 32.6787L1.38778 72.6788C-0.462592 74.1246 -0.462592 76.4699 1.38778 77.9157C3.23815 79.3614 6.23859 79.3614 8.09093 77.9157L19.3608 69.1099C27.6638 69.0883 35.9609 68.7195 44.2086 67.9743C54.7585 67.1349 63.3475 63.89 70.3624 59.2503H50.4482L79.4051 51.7082C81.6244 49.4107 83.6207 46.9697 85.4119 44.4377H69.4056L90.4225 36.2275C98.69 20.5 100.643 4.05186 101 0Z",
    fill: "#DAE7E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeaf);
export default __webpack_public_path__ + "static/media/IconLeaf.31e762405044463a197eb5785b400dc9.svg";
export { ForwardRef as ReactComponent };